import {Component, OnInit} from '@angular/core';
import {ModalComponent} from 'app/core/modal.component';
import {ModalController} from '@ionic/angular';
import {CustomDate} from 'app/core/classes/customDate';
import {HelperService} from 'app/services/helper.service';
import {DateSelectMode, DateSelectView, DateType} from 'app/entities/enums';
import {MbscDatepickerOptions} from '@mobiscroll/angular';

// DON'T FORGET INCLUDE MODULE OF MODAL INTO PAGE MODULE, or it will not work
@Component({
  selector: 'app-date-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})

/**
 * Configurable params:
 * - selectView - (optional) вид выбора даты: календарь или пикер
 * - mode       - (optional) режим выбора: выбор одной даты или области дат
 * - dateType   - (optional) тип пикера для даты (используется только в режиме selectView: 'picker')
 * - inputDate  - Дата. Только в виде даты. Дата в виде строки приведет к ошибке.
 * - min        - (optional) ограничение доступных для выбора дат
 * - max        - (optional) ограничение доступных для выбора дат
 *
 *  Usage:
 * ```
 *     this.appService.appModalService.openDatePickerModal({
 *       inputDate: this.value ? new CustomDate(this.value) : new CustomDate(),
 *       min: this.getMinDate(),
 *       max: this.getMaxDate()
 *     }, (data: CustomDate) => {
 *     });
 * ```
 * или:
 * ```
 *    this.appService.appModalService.openDatePickerModal({
 *       mode: 'range',
 *       inputDate: [new CustomDate('Apr 24 2023'), new CustomDate('Apr 29 2023')],
 *     }, (data: CustomDate) => {
 *     });
 * ```
 *
 *  Если mode === 'range', то принимается (в параметр InputDate) и возвращается массив из двух дат формата:
 *    [CustomDate, CustomDate]
 *  со значениями соответственно:
 *    [start, end]
 *  Если mode === 'single', то принимается (в параметр InputDate) и возвращается переменная типа CustomDate
 */

export class DateModalComponent extends ModalComponent implements OnInit {

  selectView: DateSelectView = 'picker';
  mode: DateSelectMode = 'single';
  dateType: DateType = 'date';
  // inputDate
  min: CustomDate = null;
  max: CustomDate = null;

  date: CustomDate | [CustomDate, CustomDate];

  pickerControls: any;
  pickerWheels = null;

  extraSettings: MbscDatepickerOptions = {
    dayNamesMin: HelperService.weekdayNamesShort
  };

  // Только в виде даты. Дата в виде строки приведет к ошибке.
  private _inputDate: CustomDate | [CustomDate, CustomDate] = null;

  get inputDate(): CustomDate | [CustomDate, CustomDate] {
    return this._inputDate;
  }

  set inputDate(value: CustomDate | [CustomDate, CustomDate]) {
    this._inputDate = value;
    this.prepareModal();
  }

  constructor(
    modalController: ModalController
  ) {
    super(modalController);
  }

  ngOnInit() {
  }

  closeModal(answer: CustomDate | [CustomDate, CustomDate] = null) {
    return super.closeModal(answer);
  }

  // При инициализации в компонент модалки приходит переменная inputDate как входящий параметр. Момент ее записи это
  // сигнал что пора инициализировать / обновить эту модалку
  prepareModal() {
    this.date = this.inputDate ? this.inputDate : null;
    if (this.selectView === 'picker') {
      this.getPickerWheels();
      this.getPickerControls();
    }
  }

  getPickerWheels() {
    if (this.dateType === 'year') {
      this.pickerWheels = '|YYYY|';
    } else if (this.dateType === 'yearmonth') {
      this.pickerWheels = '|MMMM|YYYY|';
    } else {
      this.pickerWheels = null;
    }
  }

  getPickerControls() {
    if (this.dateType === 'time') {
      this.pickerControls = ['time'];
    } else if (this.dateType === 'datetime') {
      this.pickerControls = ['datetime'];
    } else {
      this.pickerControls = ['date'];
    }
  }
}
